import React from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <>
      <Navigation />
      <section className="max-w-3xl mx-auto px-6 py-32 text-center">
        <div className="eyebrow">Page not found</div>
        <h1 className="press-title text-5xl md:text-6xl text-ink mt-3">This corridor has no door.</h1>
        <Link to="/" className="inline-block mt-10 text-burgundy underline underline-offset-4 font-serif" data-testid="not-found-home-link">Return to the house</Link>
      </section>
      <Footer />
    </>
  );
}
